<template>
  <div class="pa-6 mt-0" style="width: 100%">
    <div class="mb-6">
      <div class="component-title">Nhập điểm thi</div>
    </div>

    <v-card outlined class="pa-6 mb-6 elevation-0">
      <MarkFilter @onFilterChanged="onFilterChanged" />
    </v-card>

    <div v-if="action.state === 'select'" class="elevation-0">
      <StudentBlankView />
    </div>
    <v-card v-else outlined class="elevation-0">
      <MarkTable :query="query" :roomSubject="roomSubject" />
    </v-card>
  </div>
</template>
<script>
import MarkFilter from '@/modules/exam/MarkFilter.vue'
import StudentBlankView from '@/components/basic/StudentBlankView.vue'
import MarkTable from '@/modules/exam/MarkTable.vue'

export default {
  components: {
    StudentBlankView,
    MarkFilter,
    MarkTable
  },
  data() {
    return {
      action: {
        state: 'select'
      },
      query: {},
      roomSubject: {}
    }
  },
  computed: {},
  methods: {
    onFilterChanged(params, roomSubject) {
      this.action.state = 'filtered'
      this.query = params
      this.roomSubject = roomSubject
    }
  }
}
</script>
<style scoped>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
</style>
